/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { InvitationsControllerEditTargetsMutationRequest, InvitationsControllerEditTargetsMutationResponse, InvitationsControllerEditTargetsPathParams, InvitationsControllerEditTargets400, InvitationsControllerEditTargets401, InvitationsControllerEditTargets403, InvitationsControllerEditTargets404, InvitationsControllerEditTargets409 } from "../../models/invitationsController/InvitationsControllerEditTargets";

function getInvitationsControllerEditTargetsUrl(id: InvitationsControllerEditTargetsPathParams["id"]) {
  const res = { method: 'PATCH', url: `/api/v1/invitations/${id}/targets` as const }  
  return res
}

/**
 * @description Adds, changes, or removes targets on a pending or expired invitation in one call, then sends the invitee an updated invitation.
 * @summary Edit invitation targets
 * {@link /api/v1/invitations/:id/targets}
 */
export async function invitationsControllerEditTargets(id: InvitationsControllerEditTargetsPathParams["id"], data?: InvitationsControllerEditTargetsMutationRequest, config: Partial<RequestConfig<InvitationsControllerEditTargetsMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<InvitationsControllerEditTargetsMutationResponse, ResponseErrorConfig<InvitationsControllerEditTargets400 | InvitationsControllerEditTargets401 | InvitationsControllerEditTargets403 | InvitationsControllerEditTargets404 | InvitationsControllerEditTargets409>, InvitationsControllerEditTargetsMutationRequest>({ method : "PATCH", url : getInvitationsControllerEditTargetsUrl(id).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}